import { render } from "./page-web-logs.vue?vue&type=template&id=2cc4a807"
import script from "./page-web-logs.vue?vue&type=script&lang=js"
export * from "./page-web-logs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__